import { Injectable } from '@angular/core';
import { SysseServicePkg } from './syssePkg.service';
import {
  entityState,
  idNameItem,
  JkJobOption,
  jkLib,
  jkRestReturn,
} from 'jk-service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Sysse } from '../_entity_sys';

@Injectable({
  providedIn: 'root',
})
export class SysseService extends SysseServicePkg {
  constructor() {
    super();
    this.columnDefsVir = [
      {
        field: 'DSCMB002',
        headerName: '公司簡稱',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
      },
      {
        field: 'PROGRAM',
        headerName: '程式名稱',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
      },
      {
        field: 'UNAME',
        headerName: '姓名',
        headerTooltip: '',
        width: 150,
        cellDataType: 'text',
      },
    ];
    this.sortFieldList = `JOBID,SE109,SE110,OK,COMPANYID,DSCMB002,USERID,UNAME,PROGID,PROGRAM,
      PRIORITY,DTREQUEST,STYLE,COMPUTER,PARAM1,
      WEEK1,WEEK2,WEEK3,WEEK4,WEEK5,WEEK6,WEEK7,HHMM,
      SE100,SE101,SE102,SE104,SE105,SE106,SE107,SE108,SE111,SE112,SE113,SE114,SE115,SE116,SE117`;
    this.sqlSelect = `SELECT SYSSE.*,DSCMB.MB002 AS DSCMB002,SYSUser.UserName AS UNAME,ADMMB.MB002 AS PROGRAM
       FROM SYSSE
       LEFT JOIN DSCMB ON COMPANYID=DSCMB.MB001
       LEFT JOIN ADMMB ON PROGID=ADMMB.MB001
       LEFT JOIN SYSUser ON SYSUser.UserID=SYSSE.USERID
      `;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY HHMM`;
    this.onAfterPost = this.sysseAfterPost.bind(this);
  }
  get style(): string {
    if (!this.item) return '';
    return this.item.STYLE;
  }
  set style(value: string) {
    if (!this.item) return;
    this.item.STYLE = value;
  }
  valueChange(value: string) {
    if (!this.item) return;
    this.item.PARAMS = value;
  }
  onMasterTabChange($event: MatTabChangeEvent) {
    //throw new Error('Method not implemented.');
  }
  async doNewSchedule(body: any, ret: jkRestReturn): Promise<jkRestReturn> {
    this.newRecord(this.item);
    return ret;
  }
override async newRecord(newItem: Sysse): Promise<Sysse> {
    await super.newRecord(newItem);
    newItem.JOBID = this.nowDate() + this.nowTime4();
    newItem.DTREQUEST = new Date();
    newItem.COMPANYID = this.dbname;
    newItem.USERID = this.userId;
    newItem.STYLE = 'A'; //API
    newItem.PROGID = 'API';
    newItem.PRIORITY = 2; // 1:最優先 2:普通
    newItem.WEEK1 = 'Y';
    newItem.WEEK2 = 'Y';
    newItem.WEEK3 = 'Y';
    newItem.WEEK4 = 'Y';
    newItem.WEEK5 = 'Y';
    newItem.WEEK6 = 'Y';
    newItem.WEEK7 = 'Y';
    newItem.SE101 = 'D';
    newItem.SE102 = 1;
    newItem.SE104 = '0000';
    newItem.SE105 = '2359';
    newItem.SE108 = 1; //每月執行日
    newItem.SE106 = this.nowDate();
    newItem.SE111 = this.nowDate();
    return newItem;
  }
  override async doMyOk(): Promise<boolean> {
    this.oldState = this.state;
    return await super.doMyOk();
  }
  async sysseAfterPost(item: any, ret: jkRestReturn): Promise<void> {
    try {
      let mUrl = '/db/sysseAfterPost';
      let body = {
        JOBID: item.JOBID,
        IsInsert: this.iif(this.oldState === entityState.dsInsert, true, false),
      };
      let config = jkLib.axiosConfigInit(this.host, mUrl, 'post', [], body);
      await jkLib.doAxios(config, ret);
      if (!ret.result) {
        let msg =
          'call sysseAfterPost error: ' +
          ret.errorLog +
          JSON.stringify(ret.obj);
        ret.addResultError(msg, true);
      }
      return;
    } catch (error: any) {
      ret.addResultError('simpleSqlPromise error: ' + error.message, true);
      return;
    }
  }
  async doParamTest() {
    if (this.state !== entityState.dsBrowse) {
      alert('瀏覽狀態才能測試');
      return;
    }
    await this.sysseAfterPost(this.item, this.jkRet);
    console.log(this.jkRet);
  }
  se100List: idNameItem[] = [];
  setSe100List(params: string) {
    if (!params) {
      this.se100List = [];
      return;
    }
    let list: idNameItem[] = [];
    try {
      const tmp: JkJobOption[] = JSON.parse(params);
      if (Array.isArray(tmp)) {
        for (let i = 0; i < tmp.length; i++) {
          let item = tmp[i];
          if (item.kind === 'query' || item.kind === 'body') {
            if (this.item.SE101 === 'D') {
              if (item.caption.indexOf('日') > -1) {
                if (item.kind.toUpperCase() == 'TJKBTNEDIT') {
                  list.push({ id: item.name, name: '*' + item.caption });
                }
                if (item.kind.toUpperCase() == 'TJKDBEDIT') {
                  list.push({ id: item.name, name: '*' + item.caption });
                }
                if (item.kind.toUpperCase() == 'TJKRANGE') {
                  list.push({ id: item.name, name: '~' + item.caption });
                }
              }
            } else if (this.item.SE101 === 'M') {
              if (item.caption.indexOf('月') > -1) {
                if (item.kind.toUpperCase() == 'TJKBTNEDIT') {
                  list.push({ id: item.name, name: '*' + item.caption });
                }
                if (item.kind.toUpperCase() == 'TJKDBEDIT') {
                  list.push({ id: item.name, name: '*' + item.caption });
                }
                if (item.kind.toUpperCase() == 'TJKRANGE') {
                  list.push({ id: item.name, name: '~' + item.caption });
                }
              }
            } else {
              list.push({ id: item.name, name: item.caption });
            }
          }
        }
      }
    } catch (error: any) {
      console.error('Invalid JSON string:', error.message);
    }
    this.se100List = list;
  }
  SE115_ADisplayOnly = false;
  se100Change() {
    if (!this.item) return;
    let mSE114_Label = '';
    if (this.item.SE101 === 'M') {
      mSE114_Label = '[下次年月]';
    }
    if (this.item.SE101 === 'D') {
      mSE114_Label = '[下次日期]';
    }

    if (this.item.SE101 === 'D') {
      if (this.item.SE100.substring(1, 1) === '*') {
        this.item.SE114 = mSE114_Label;
        this.item.SE115 = '';
        this.SE115_ADisplayOnly = true;
      } else {
        this.item.SE114 = mSE114_Label;
        this.item.SE115 = mSE114_Label;
        this.SE115_ADisplayOnly = false;
      }
    }
  }
}
